import { PRODUCT_TYPES, STATE } from './constants';

export const selectedDry = (ctx, { payload }) =>
  payload.mealPrepType === PRODUCT_TYPES.dry;

export const hasRecipes = ctx => {
  switch (ctx.mealPrepType) {
    case PRODUCT_TYPES.fresh:
      return !!ctx.recipes.fresh.length;
    case PRODUCT_TYPES.dry:
      return !!ctx.recipes.dry.length;
    case PRODUCT_TYPES.mixed:
      return !!ctx.recipes.fresh.length && !!ctx.recipes.mixed.length;
    default:
      return false;
  }
};

export const hasFreshInCart = (ctx, { payload: { recipes } }) =>
  !!recipes.fresh?.length;
export const hasDryInCart = (ctx, { payload: { recipes } }) =>
  !!recipes.dry?.length;

export const hasMealPrep = ctx => !!ctx.mealPrepType;
export const isFresh = ctx => ctx.mealPrepType === PRODUCT_TYPES.fresh;
export const isBaked = ctx => ctx.mealPrepType === PRODUCT_TYPES.dry;
export const isMixed = ctx => ctx.mealPrepType === PRODUCT_TYPES.mixed;
export const isBakedOrMixed = ctx => isBaked(ctx) || isMixed(ctx);
export const isFreshOrMixed = ctx => isFresh(ctx) || isMixed(ctx);
export const isFreshUrl = (ctx, { payload }) =>
  payload.pathname === STATE.fresh;
export const isBakedUrl = (ctx, { payload }) =>
  payload.pathname === STATE.baked;
export const prevStateBaked = ctx => ctx.prevState === STATE.baked;
export const prevStateFresh = ctx => ctx.prevState === STATE.fresh;
export const submitCartFailed = (ctx, payload) => !payload.data.success;
